import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0a9975de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-dashboard-container" }
const _hoisted_2 = {
  key: 1,
  class: "stats-cards-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentContainerNavbar = _resolveComponent("ContentContainerNavbar")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_empty_state = _resolveComponent("v-empty-state")!
  const _component_FormStatsCard = _resolveComponent("FormStatsCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ContentContainerNavbar, {
      title: "Dashboard",
      searchBarPlaceholder: _ctx.$t('i18n.searchBarPlaceholder'),
      dateFilter: true,
      searchBar: "",
      onDateRangeInput: _ctx.handleDateRange,
      onSearchInput: _ctx.handleFormSearch
    }, null, 8, ["searchBarPlaceholder", "onDateRangeInput", "onSearchInput"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
          key: 0,
          type: "table"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.formList.length === 0)
            ? (_openBlock(), _createBlock(_component_v_empty_state, {
                key: 0,
                icon: "mdi-magnify",
                headline: _ctx.$t('i18n.noForms'),
                text: _ctx.$t('i18n.noFormsText'),
                title: ""
              }, null, 8, ["headline", "text"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOrderedForms, (form) => {
            return (_openBlock(), _createBlock(_component_FormStatsCard, {
              key: form.id,
              form: form,
              dateRange: _ctx.dateRange
            }, null, 8, ["form", "dateRange"]))
          }), 128))
        ]))
  ]))
}